// An extremely basic regex for making sure some email-like string is
// provided.
export default function validateEmailBasic(email) {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
}



/** WEBPACK FOOTER **
 ** ./src/_shared/lib/validate-email-basic/index.js
 **/